import React, { useState, useEffect } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const categoryMeta = [
  { id: 'sofa', name: 'Sofa Jati' },
  { id: 'meja-makan', name: 'Meja Makan' },
  { id: 'daybed', name: 'Daybed' },
  { id: 'almari', name: 'Almari Jati' },
  { id: 'bilik-tidur', name: 'Set Bilik Tidur' },
  { id: 'kabinet-tv', name: 'Kabinet TV' },
];

const CategoriesSection = () => {
  const [categories, setCategories] = useState(categoryMeta.map(c => ({ ...c, image: '', count: 0 })));

  useEffect(() => {
    fetch(`${API_URL}/api/products`)
      .then(res => res.json())
      .then(products => {
        setCategories(categoryMeta.map(cat => {
          const match = products.filter(p => p.category === cat.id);
          return {
            ...cat,
            image: match[0]?.images?.[0] || '',
            count: match.length,
          };
        }));
      })
      .catch(() => {});
  }, []);

  return (
    <section id="category" className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Kategori Perabot
          </h2>
          <p className="text-sm text-gray-600">
            Lawati gudang kami untuk lihat koleksi penuh
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-testid="categories-grid">
          {categories.map(category => (
            <a
              key={category.id}
              href="#perabot"
              className="group block"
              data-testid={`category-${category.id}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden rounded-xl bg-gray-200">
                {category.image && (
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="text-white font-semibold text-sm md:text-base">{category.name}</h3>
                  {category.count > 0 && (
                    <p className="text-white/80 text-xs mt-0.5">{category.count} produk</p>
                  )}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CategoriesSection;
